import {computed, ref} from "vue";
import {useMutation, useQuery} from "@tanstack/vue-query";
import axios from "axios";
import moment from "moment";

const perPage = ref(10);
const currentPage = ref(1);
const orderBy = ref('created_at');
const orderDirection = ref('desc');
const email = ref('');

const showModal = ref(false);
const modalEmail = ref({});
const emailHtml = ref('');
const emailHtmlError = ref('');

const viewEmailHtml = (email) => {
  modalEmail.value = email;
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  modalEmail.value = {};
  emailHtml.value = '';
  emailHtmlError.value = '';
};

const defaultDateRange = [
  moment().subtract(1, 'month').format(),
  moment().format(),
];

const dateRange = ref(defaultDateRange);

const handlePageChange = (page) => {
  currentPage.value = page;
};

export const useEmailLogs = () => {
  if (dateRange.value.length === 0) {
    dateRange.value = defaultDateRange;
  }

  const query = useQuery({
    queryKey: ['emailLogs', dateRange, currentPage, orderBy, orderDirection, email],
    queryFn: async () => {
      const queryString = new URLSearchParams({
        email: email.value,
        page: currentPage.value,
        perPage: perPage.value,
        fromDate: dateRange.value[0],
        toDate: dateRange.value[1],
        orderBy: orderBy.value,
        orderDirection: orderDirection.value,
      });

      const {data} = await axios.get(`/ajax/v2/email-logs?${queryString.toString()}`);

      return data;
    },
    enabled: () => !!email.value,
  });

  const getEmailHtml = () => useMutation({
    mutationFn: async (emailId) => {
      const {data} = await axios.get(`/ajax/v2/email-logs/${emailId}/html`);
      return data;
    },
    onSuccess: (data) => {
      emailHtml.value = data.html;
    },
    onError: () => {
      emailHtml.value = '';
      emailHtmlError.value = 'Something went wrong';
    },
  });

  const sentEmails = computed(() => {
    return query?.data?.value?.emails ?? [];
  });

  const queryMeta = computed(() => {
    return query?.data?.value?.meta ?? {};
  });

  const lastPage = computed(() => queryMeta.value.last_page ?? 0);

  return {
    ...query,
    email,
    sentEmails,
    queryMeta,
    currentPage,
    dateRange,
    orderBy,
    orderDirection,
    lastPage,
    handlePageChange,

    viewEmailHtml,
    closeModal,
    modalEmail,
    showModal,
    emailHtml,
    emailHtmlError,
    getEmailHtml,
  };
};
